// --- COMPONENT: ABOUT SECTION ---
import { ASSETS } from "../assets/assets";

const AboutSection = () => {
  return (
    <section className="bg-[#050505] text-white pt-3 pb-20 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">

        {/* ================= DESKTOP ================= */}
        <div className="hidden lg:block">
          
          {/* Bagian Atas */}
          <div className="flex flex-row items-center gap-12 mb-6">
            
            {/* Runner */}
            <div className="w-1/3 relative group">
              <img 
                src={ASSETS.runnerAbout} 
                alt="Trail Runner" 
                className="w-full object-cover rounded-xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500"
              />
            </div>

            {/* Text */}
            <div className="w-1/2">
              <h2 className="text-4xl font-bold mb-6 leading-tight">
                About Experiences on <br />
                <span className="text-[#DFFF00]">The Slopes of Semeru</span>
              </h2>

              <p className="text-gray-400 leading-relaxed mb-6 text-base text-justify">
                Alas Trail Run adalah ajang lari lintas alam yang menghadirkan pengalaman berlari di kaki Gunung Semeru — gunung tertinggi di Pulau Jawa. Melalui jalur hutan, perbukitan, dan pedesaan di kawasan Semeru, peserta diajak menyatu dengan alam sambil menantang batas diri mereka.
              </p>

              {/* Thumbnails */}
              <div className="flex gap-4 mt-8">
                <div className="w-[260px] h-[160px] bg-gray-800 rounded overflow-hidden border border-gray-700">
                  <img src={ASSETS.ASimg1} className="w-full h-full object-cover" />
                </div>
                <div className="w-[260px] h-[160px] bg-gray-800 rounded overflow-hidden border border-gray-700">
                  <img src={ASSETS.ASimg2} className="w-full h-full object-cover" />
                </div>
              </div>
            </div>

            {/* Start Image */}
            <div className="w-1/4">
              <div className="bg-gray-800 p-2 rotate-3 hover:rotate-0 transition rounded-xl">
                <img src={ASSETS.start} className="w-full object-cover rounded-lg" />
              </div>
            </div>
          </div>

          {/* Bagian Bawah */}
          <div className="flex gap-8 items-center">
            <div className="w-1/2">
              <img src={ASSETS.ortu} className="w-full h-64 object-cover rounded-lg shadow-lg opacity-80" />
            </div>
            <div className="w-1/2 pl-10 border-l border-gray-800">
              <p className="text-gray-300 italic leading-loose">
                 "Event ini bukan sekadar lomba lari, tetapi sebuah perjalanan spiritual 
                  dan petualangan yang memadukan olahraga, keindahan alam, serta semangat 
                  pelestarian lingkungan. Dengan udara pegunungan yang sejuk dan panorama 
                  hutan yang memukau, Alas Trail Run menjadi simbol kebebasan, ketangguhan, 
                  dan kecintaan terhadap alam Semeru."
              </p>
            </div>
          </div>
        </div>

        {/* ================= MOBILE ================= */}
        <div className="block lg:hidden">

          {/* Runner kecil */}
          <div className="flex justify-center mb-6">
            <img
              src={ASSETS.runnerAbout}
              alt="Trail Runner"
              className="w-[200px] object-contain"
            />
          </div>

          {/* Text */}
          <h2 className="text-2xl font-bold mb-4">
            About Experiences on <br />
            <span className="text-[#DFFF00]">The Slopes of Semeru</span>
          </h2>

          <p className="text-gray-400 text-sm leading-relaxed mb-6 text-justify">
            Alas Trail Run adalah ajang lari lintas alam yang menghadirkan pengalaman berlari di kaki Gunung Semeru — gunung tertinggi di Pulau Jawa. Melalui jalur hutan, perbukitan, dan pedesaan di kawasan Semeru, peserta diajak menyatu dengan alam sambil menantang batas diri mereka.
          </p>

          {/* Image group */}
          <div className="space-y-4">
            <div className="h-[160px] bg-[#0d0d0d] rounded overflow-hidden">
              <img src={ASSETS.ASimg1} className="w-full h-full object-contain" />
            </div>
            <div className="h-[160px] bg-[#0d0d0d] rounded overflow-hidden">
              <img src={ASSETS.ASimg2} className="w-full h-full object-contain" />
            </div>
            <div className="h-[200px] bg-[#0d0d0d] rounded overflow-hidden">
              <img src={ASSETS.start} className="w-full h-full object-contain" />
            </div>
          </div>

          {/* Quote */}
          <div className="mt-8">
            <img src={ASSETS.ortu} className="w-full h-56 object-cover rounded-lg mb-4" />
            <p className="text-gray-300 text-sm italic leading-loose">
              "Event ini bukan sekadar lomba lari, tetapi sebuah perjalanan spiritual 
              dan petualangan yang memadukan olahraga, keindahan alam, serta semangat 
              pelestarian lingkungan. Dengan udara pegunungan yang sejuk dan panorama 
              hutan yang memukau, Alas Trail Run menjadi simbol kebebasan, ketangguhan, 
              dan kecintaan terhadap alam Semeru."
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutSection;